import ForbesDashboardView from "src/sections/dashboards/platforms/forbes/forbes-dashboard-view";

const ForbesCustomDashboardPage = () => <ForbesDashboardView type="custom" />;

export default ForbesCustomDashboardPage;
